import React from 'react'
import Courses from '../Courses/Courses'

const Events = () => {
  return (
   <Courses  defaultCategory='event'/>
  )
}

export default Events
